import { Box, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { designTokens } from '../tokens';
import { progressMarkerStyles } from '../progressStyles';

export type ProgressStepProps = {
  marker: ReactNode;
  label: ReactNode;
  description: ReactNode;
  active?: boolean;
  tone?: 'neutral' | 'active' | 'success' | 'danger';
};

export function ProgressStep({ marker, label, description, active = false, tone }: ProgressStepProps) {
  const resolvedTone = tone ?? (active ? 'active' : 'neutral');
  const emphasized = resolvedTone !== 'neutral';
  return (
    <Stack direction="row" spacing={1} sx={{ minWidth: 0, alignItems: 'flex-start', py: 1 }}>
      <Box component="span" sx={progressMarkerStyles(resolvedTone)}>{marker}</Box>
      <Box sx={{ minWidth: 0, flex: 1, display: 'grid', gridTemplateColumns: { xs: 'minmax(0, 1fr)', sm: `${designTokens.progress.labelWidth}px minmax(0, 1fr)` }, columnGap: 1, rowGap: 0.5, pt: '2px' }}>
        <Typography component="div" variant="body2" sx={{ fontWeight: resolvedTone === 'active' ? 600 : 500, color: resolvedTone === 'active' ? designTokens.color.actionDark : 'text.primary', overflowWrap: 'anywhere' }}>{label}</Typography>
        <Typography component="div" variant="body2" sx={{ minWidth: 0, color: emphasized ? 'text.primary' : 'text.secondary', overflowWrap: 'anywhere' }}>{description}</Typography>
      </Box>
    </Stack>
  );
}
